import scrollLock from './functions/_scrollLock.js' // スクロールロック
import $ from 'jquery' // jQuery
import { gsap, ScrollTrigger, Draggable, MotionPathPlugin } from 'gsap/all'

// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,
if (document.getElementById('page-top')) {
  pageTop()
}
function pageTop() {
  /*
#### ##    ## ########          #######  ########   ######
 ##  ####  ##    ##            ##     ## ##     ## ##
 ##  ## ## ##    ##    ####### ##     ## ########   ######
 ##  ##  ####    ##            ##     ## ##     ##       ##
#### ##    ##    ##             #######  ########   ######
*/
  $(function () {
    if (document.getElementsByClassName('js-in')[0]) {
      // 画面に入った監視対象に.animatedを付加
      // Intersection Observer
      intObs()
    }
    function intObs() {
      let rootMargin = '-100px 0px'
      if (window.matchMedia('(max-width:768px)').matches) {
        //SPは検出を早くする
        rootMargin = '100px 0px'
      }
      const intObsOption = {
        // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
        rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
        threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
      }
      const observer = new IntersectionObserver(intObsCallback, intObsOption)
      const intObsItems = document.getElementsByClassName('js-in')
      for (let index = 0; index < intObsItems.length; index++) {
        const intObsItem = intObsItems[index]
        observer.observe(intObsItem) // 監視対象に加える
      }
      function intObsCallback(entries) {
        for (let index = 0; index < entries.length; index++) {
          const entry = entries[index]
          if (entry.isIntersecting) {
            const entryItem = entry.target
            entryItem.classList.add('active')
            observer.unobserve(entryItem) // 監視対象から外す
          }
        }
      }
    }
  })

  //
  //  ##       #####     ###    ####    ##  ##     ##   ####
  //  ##      ##   ##   ## ##   ##  ##  ##  ####   ##  ##
  //  ##      ##   ##  ##   ##  ##  ##  ##  ##  ## ##  ##  ###
  //  ##      ##   ##  #######  ##  ##  ##  ##    ###  ##   ##
  //  ######   #####   ##   ##  ####    ##  ##     ##   ####
  //





    // MVスライダー（10秒パン + ラスト2秒で次スライドも移動開始しつつクロスフェード）
    initTopMvSlider()
    function initTopMvSlider() {
      const slides = gsap.utils.toArray('.js-topMvSlide')
      if (!slides.length) return

      const FADE = 2
      // PC: 10秒・0→右へ / SP: 8秒・画像幅430/390に合わせた小さな移動
      const getPanConfig = () => {
        if (window.matchMedia('(max-width:768px)').matches) {
          // はみ出し約9.3%分だけ左→右へ（余白を出さず右側も見えすぎない）
          return { from: -6, to: 0, duration: 8 }
        }
        return { from: 0, to: 5, duration: 10 }
      }

      const initialPan = getPanConfig()
      gsap.set(slides, { autoAlpha: 0, zIndex: 1 })
      gsap.set(slides[0], { autoAlpha: 1, zIndex: 2 })
      // 表示前に全スライドを開始位置へ（1枚目の初期余白防止）
      slides.forEach((slide) => {
        gsap.set(slide.querySelector('.js-topMvPan'), { xPercent: initialPan.from })
      })

      const cycle = (index, prev) => {
        const current = slides[index]
        const nextIndex = (index + 1) % slides.length
        const pan = current.querySelector('.js-topMvPan')
        const { from, to, duration } = getPanConfig()

        gsap.set(pan, { xPercent: from })
        gsap.set(current, { zIndex: 2 })
        if (prev) {
          gsap.set(prev, { zIndex: 1 })
          gsap.to(prev, { autoAlpha: 0, duration: FADE, ease: 'power1.inOut' })
          gsap.to(current, { autoAlpha: 1, duration: FADE, ease: 'power1.inOut' })
        } else {
          gsap.set(current, { autoAlpha: 1 })
        }

        // 左から右へ移動（裏で動き続ける）
        gsap.to(pan, {
          xPercent: to,
          duration,
          ease: 'none',
        })

        // 終了2秒前に次スライドを左端から移動開始＋クロスフェード
        gsap.delayedCall(duration - FADE, () => {
          cycle(nextIndex, current)
        })
      }

      cycle(0, null)
    }



  $(window).scroll(function () {
    let scrollTop = $(window).scrollTop() // スクロール上部の位置
    let target = $('#topPolicy')
    let areaTop = target.offset().top // 対象エリアの上部の位置
    let areaBottom = areaTop + target.innerHeight() // 対象エリアの下部の位置
    if (scrollTop > areaTop - 300 && scrollTop < areaBottom) {
      $('.js-copy-bg').addClass('fade') // スクロールが対象エリアに入った場合
    } else {
      $('.js-copy-bg').removeClass('fade') // スクロールが対象エリアから出ている場合
    }
  })

  function runAnimations() {
    // 右から左へ動くアニメーション
    $('.slide-right').each(function () {
      let elementTop = $(this).offset().top - 50
      let scrollPosition = $(window).scrollTop()
      let windowHeight = $(window).height()

      if (scrollPosition >= elementTop - windowHeight) {
        $(this).addClass('slide-in-from-right')
        $(this).children('.slide-right-inner').addClass('slide-in-from-left')
      } else {
        $(this).removeClass('slide-in-from-right')
        $(this).children('.slide-right-inner').removeClass('slide-in-from-left')
      }
    })

    // 左から右へ動くアニメーション
    $('.slide-left').each(function () {
      let elementTop = $(this).offset().top - 50
      let scrollPosition = $(window).scrollTop()
      let windowHeight = $(window).height()

      if (scrollPosition >= elementTop - windowHeight) {
        $(this).addClass('slide-in-from-left')
        $(this).children('.slide-left-inner').addClass('slide-in-from-right')
      } else {
        $(this).removeClass('slide-in-from-left')
        $(this).children('.slide-left-inner').removeClass('slide-in-from-right')
      }
    })
  }

  // スクロール時にアニメーションを実行
  $(window).scroll(function () {
    runAnimations()
  })

  $(document).ready(function () {
    // 文字列へのspan設定
    $('.js-title').each(function () {
      var content = $(this).html()
      var trimText = $.trim(content)
      var newText = ''
      trimText.split('').forEach(function (e) {
        if (e == ' ') {
          // 空白対策
          newText += '<span> </span>'
        } else {
          newText += '<span>' + e + '</span>'
        }
      })
      $(this).html(newText)
    })
  })
}


$(document).ready(function () {
  $('.js-title02').each(function () {
    var content = $(this).html().trim(); // .html() で取得し、<br> を含める
    var newText = content
      .split(/(<br\s*\/?>)/) // <br> を分割の対象に含める
      .map(function (part) {
        if (part.toLowerCase().startsWith('<br')) {
          return part; // <br> はそのまま保持
        }
        return part
          .split('')
          .map(function (char) {
            return char === ' ' ? '<span>&nbsp;</span>' : '<span>' + char + '</span>';
          })
          .join('');
      })
      .join('');
    $(this).html(newText);
  });
});

